import React, { createContext, useContext } from 'react';

/**
 * HeaderThemeContext — lets widgets rendered inside the app Header
 * (currency selector, notification bells, status pills, …) inherit a
 * readable colour scheme automatically instead of each one hard-coding
 * light/dark classes. The Header wraps its content in
 * <HeaderThemeProvider onDark> so any current or future child can call
 * useHeaderTheme() and adapt. Defaults to light (onDark:false) so the
 * same components stay correct if reused on a light surface.
 */
const HeaderThemeContext = createContext({ onDark: false });

export function HeaderThemeProvider({ onDark = false, children }) {
  return (
    <HeaderThemeContext.Provider value={{ onDark }}>
      {children}
    </HeaderThemeContext.Provider>
  );
}

export function useHeaderTheme() {
  return useContext(HeaderThemeContext);
}
